module.exports = __webpack_public_path__ + "static/theme-e59f39b3d41bb5f969da216aacd02360.png";